import React from 'react';
import { Link } from 'react-router-dom';
import { useContact } from 'src/features/contacts';
import { ROUTES } from 'src/navigation';

type Props = {
  contactId?: string;

  type?: 'name' | 'email' | 'phone';
};

const ContactLink: React.FC<Props> = ({ contactId, type = 'name' }) => {
  const { contact, isLoading } = useContact(contactId);

  if (isLoading) {
    return <span>...</span>; // TODO: Skeleton/loading component
  }

  if (!contact) {
    return null;
  }

  if (!contactId) {
    return null;
  }

  if (type === 'phone') {
    if (!contact.mobilePhone) {
      return null;
    }

    return <a href={`tel:${contact.mobilePhone}`}>{contact.mobilePhone}</a>;
  }

  if (type === 'email') {
    if (!contact.emailAddress) {
      return null;
    }

    return <a href={`mailto:${contact.emailAddress}`}>{contact.emailAddress}</a>;
  }

  const fullName = `${contact.firstName} ${contact.lastName}`;

  return <Link to={ROUTES.RESOURCE_BASE.CONTACTS.DETAILS(contactId).BASE}>{fullName}</Link>;
};

export default ContactLink;
